import React from "react";
import { InputLabel, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import ActionChips from "../compliance/ActionChips";
import ConditionChips from "../compliance/ConditionChips";

const StyledFormLabel = styled(InputLabel)({
    fontSize: "13px",
    color: "#9E9E9E",
    textTransform: "uppercase",
});

const StyledTypography = styled(Typography)({
    fontSize: "0.875rem",
});

const StyledComplianceRulesByDocumentTypeContainer = styled("div")({
    marginLeft: "22px",
});

const StyledComplianceRulesByDocumentTypeItem = styled("div")({
    padding: "0.5vh 0",
});

const ComplianceRulesByDocumentType = (props) => {
    const { rule } = props;
    const { ruleName } = rule;

    return (
        <React.Fragment>
            <StyledFormLabel shrink>{ruleName}</StyledFormLabel>
            <StyledComplianceRulesByDocumentTypeContainer>
                <StyledComplianceRulesByDocumentTypeItem>
                    <StyledTypography>Action</StyledTypography>
                </StyledComplianceRulesByDocumentTypeItem>
                <StyledComplianceRulesByDocumentTypeItem>
                    <ActionChips rule={rule} />
                </StyledComplianceRulesByDocumentTypeItem>
                <StyledComplianceRulesByDocumentTypeItem>
                    <StyledTypography>Conditions</StyledTypography>
                </StyledComplianceRulesByDocumentTypeItem>
                <StyledComplianceRulesByDocumentTypeItem>
                    <ConditionChips rule={rule} />
                </StyledComplianceRulesByDocumentTypeItem>
            </StyledComplianceRulesByDocumentTypeContainer>
        </React.Fragment>
    );
};

export default ComplianceRulesByDocumentType;
